import React from "react";
import { Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import FilUploadWithButtonPage from "./FilUploadWithButtonPage";
import FilUploadWithButtonPageCircle from "./FilUploadWithButtonPageCircle";
import BasicFileUploadPage from "./BasicFileUploadPage";

const FileUploadPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"File Upload"} description={"File Upload"} />

      <BasicFileUploadPage />
      <FilUploadWithButtonPage />
      <FilUploadWithButtonPageCircle />
    </Paper>
  );
};

export default FileUploadPage;
